export default __webpack_public_path__ + "static/media/mask4.12d6f674.jpeg";